import React from "react";
import { makeStyles } from "@mui/styles";
import { colors } from "src/colors/colors";
import { useCheckLoading } from "../../providers/checkLoadingProvider";
const useStyles = makeStyles((theme) => {
  return {
    popupModal: {
      zIndex: 9999,
      background: "rgba(0, 0,0, 0.1)",
      position: "fixed",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      ...theme.custom.flexBox.flexCenterCenter,
    },
    loadingSpinnerRolling: {
      width: "200px",
      height: "200px",
      display: "block",
      overflow: "hidden",
      margin: "auto",
    },
    loading: {
      width: "100%",
      height: "100%",
      position: "relative",
      transform: "translateZ(0) scale(1)",
      backfaceVisibility: "hidden",
      transformOrigin: "0 0",
    },
    loadingItem: {
      position: "absolute",
      width: " 64px",
      height: " 64px",
      border: `6px solid ${colors.background.blueButton}`,
      borderTopColor: "transparent",
      borderRadius: "50%",
      animation: "loading 1s linear infinite",
      top: "100px",
      left: "100px",
      boxSizing: "content-box",
    },
  };
});
const LoadingPage = () => {
  const { isLoading } = useCheckLoading();
  const classes = useStyles();
  return (
    <>
      {isLoading && (
        <div className={classes.popupModal}>
          <div className={classes.loadingSpinnerRolling}>
            <div className={classes.loading}>
              <div className={classes.loadingItem}></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingPage;
